module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_1_3.85a0ace9.png";